import i18n, { Resource } from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './translations/en'
import fi from './translations/fi'
import swe from './translations/swe'
import de from './translations/de'
import no from './translations/no'
import fr from './translations/fr'
import nl from './translations/nl'
import es from './translations/es'
import Language from './enums/Language'
import { isValidLanguage } from './utils/language'
import { DEFAULT_LANGUAGE } from './constants'

const getFallbackLng = (): Language => {
  const language = window.localStorage.getItem('language') ?? DEFAULT_LANGUAGE

  if (isValidLanguage(language)) {
    return language
  }

  return DEFAULT_LANGUAGE
}

const warnedKeys = new Set<string>([])

// README: If you make changes to this file, by either adding languages
// or namespaces, then add them also to the `checkMissingTranslationKeys.js` script
// and to the 18n parser config file, to make the missing translations script work

// Here is a prompt to generate other language translations from a json file:
// Translate this JSON to German, English, Spanish, Finnish, French, Dutch, Norwegian (Bokmål) and Swedish:
const resources: Record<Language, Resource> = {
  fi,
  en,
  swe,
  de,
  no,
  fr,
  nl,
  es
}

i18n.use(initReactI18next).init({
  ns: [
    'actionRequest',
    'actions',
    'alert',
    'asset',
    'breadcrumbs',
    'catalogProduct',
    'common',
    'graph',
    'generator',
    'device',
    'heater',
    'installation',
    'manufacturing',
    'powerSupply',
    'ruuvitag',
    'sms',
    'validation',
    'valve'
  ],
  defaultNS: 'common',
  resources,
  fallbackLng: getFallbackLng(),
  interpolation: {
    escapeValue: false
  },
  saveMissing: true,
  missingKeyHandler: (lng, ns, key, _fallbackValue) => {
    if (!warnedKeys.has(key)) {
      console.warn(
        `🚨 Missing translation key: "${key}" in namespace "${ns}" for language "${lng}"`
      )
      warnedKeys.add(key)
    }
  }
})
